import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const FootExamHistoryPage = lazy(() => import("./FootExamHistoryPage"));

const FootExamHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <FootExamHistoryPage />
    </Suspense>
  );
};

export default FootExamHistoryPageLazy;
